var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "help_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#help_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.991 14.68a.82.82 0 0 0 .603-.247.82.82 0 0 0 .246-.603.82.82 0 0 0-.246-.603.82.82 0 0 0-.603-.246.82.82 0 0 0-.603.246.82.82 0 0 0-.246.604.82.82 0 0 0 .246.603.82.82 0 0 0 .603.246m.011 3.237a7.7 7.7 0 0 1-3.088-.623A8 8 0 0 1 4.4 15.602a8 8 0 0 1-1.692-2.514 7.7 7.7 0 0 1-.624-3.086q0-1.643.623-3.088A8 8 0 0 1 4.4 4.4a8 8 0 0 1 2.513-1.693A7.7 7.7 0 0 1 10 2.084q1.642 0 3.088.623 1.444.623 2.514 1.692a8 8 0 0 1 1.693 2.513q.623 1.444.623 3.087a7.7 7.7 0 0 1-.623 3.087 8 8 0 0 1-1.692 2.515 8 8 0 0 1-2.513 1.692 7.7 7.7 0 0 1-3.087.624m-.001-1.25q2.79 0 4.729-1.938 1.937-1.937 1.937-4.729T14.73 5.271Q12.793 3.334 10 3.334q-2.79 0-4.729 1.937-1.937 1.937-1.937 4.73 0 2.79 1.937 4.728t4.73 1.938m.067-10.234q.577 0 .998.363t.422.908q0 .458-.27.82-.269.363-.615.675a5.3 5.3 0 0 0-.799.886q-.345.482-.369 1.075a.47.47 0 0 0 .16.382.56.56 0 0 0 .393.154q.24 0 .407-.16a.73.73 0 0 0 .213-.393q.084-.43.355-.765.271-.336.589-.639a5.6 5.6 0 0 0 .795-.968q.34-.525.34-1.17 0-.99-.78-1.627a2.8 2.8 0 0 0-1.823-.637q-.744 0-1.402.329-.66.33-1.026.96a.57.57 0 0 0-.073.409q.04.214.22.325a.64.64 0 0 0 .468.073.7.7 0 0 0 .409-.274 2 2 0 0 1 .613-.527q.36-.2.775-.2"
  }))));
};
export default SvgHelp;